import { useEffect, useState } from 'react';

import { useContent } from '../../hooks/useContent';
import { useEvent } from '../../utils/analytics/useEvent';

export const useFieldErrorAnalytics = ({
  invalidFields,
  field,
  contentPathRoot,
}: {
  invalidFields: string[];
  field: string;
  contentPathRoot?: string;
}) => {
  const trackEvent = useEvent();
  const [trackedError, setTrackedError] = useState(false);
  const { getContentByPath } = useContent();

  useEffect(() => {
    if (invalidFields.includes(field)) {
      if (!trackedError) {
        trackEvent(
          'identity – mlife - registration input error',
          'mlife registration input error',
          'mlifereginputerror',
          {
            errorField: getContentByPath(
              contentPathRoot ? `${contentPathRoot}.title` : `accountCreation.fields.${field}.title`,
            ),
            errorDisplayed: getContentByPath(
              contentPathRoot ? `${contentPathRoot}.error` : `accountCreation.fields.${field}.error`,
            ),
          },
        );
        setTrackedError(true);
      }
    } else {
      setTrackedError(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getContentByPath, invalidFields, trackEvent]);
};
